import { create } from 'zustand'
import { persist } from 'zustand/middleware';

interface User {
  id: string;
  email: string;
  transportId: string;
  isAvailable: boolean;
  firstName: string;
  lastName: string;
  licensePlate: string;
  phone: string;
  whatsapp?: string;
  startTime?: string;
  endTime?: string;
  isPublic: boolean;
  paymentMethods?: string[];
  categoryName?: string;
}

interface AuthStore {
  token: string | null;
  user: User | null;
  isAuthenticated: boolean;
  login: (token: string, user: User) => void;
  logout: () => void;
}

export const useAuthStore = create(
  persist<AuthStore>(
    (set: any) => ({
      token: null,
      user: null,
      isAuthenticated: false,
      login: (token: string, user: User) => set({ token, user, isAuthenticated: true }),
      logout: () => set({ token: null, user: null, isAuthenticated: false }),
    }),
    {
      name: 'auth-storage',
    }
  )
); 